export enum DropDownPresentationType {
    DropDown = 1,
    Key = 2
}